import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { useGuideTour } from '../provider/guideTourContext'
import { getGuideTourStepRoute, matchGuideTourRoute } from './utils'

/** Navigates to the active step route when a multi-route tour changes steps. */
export const GuideTourStepRouteNavigator = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { state, originRouteRestore, clearOriginRouteRestore } = useGuideTour()

  useEffect(() => {
    if (!originRouteRestore) {
      return
    }

    if (matchGuideTourRoute(originRouteRestore, pathname)) {
      clearOriginRouteRestore()
      return
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- react-router navigate in effect
    navigate(originRouteRestore)
  }, [clearOriginRouteRestore, navigate, originRouteRestore, pathname])

  useEffect(() => {
    if (state.status !== 'active' || !state.activeTour) {
      return
    }

    const step = state.activeTour.steps[state.currentStepIndex]

    if (!step) {
      return
    }

    const route = getGuideTourStepRoute(state.activeTour, step)

    if (!route || matchGuideTourRoute(route, pathname)) {
      return
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- react-router navigate in effect
    navigate(route)
  }, [
    navigate,
    pathname,
    state.activeTour,
    state.currentStepIndex,
    state.status,
  ])

  return null
}
